import { GraphDownArrow, GraphUpArrow } from "components/Icons";
import { OpinionModel } from "components/Opinion/Opinion.hooks";
import { ElementType } from "react";
import { Link } from "react-router-dom";
import { useStockQuery } from 'components/Stock/Stock.hooks';
import { useUserQuery } from 'components/User';

export type ArticleHeaderProps = {
  isShowDirection?: boolean;
  isShowStock?: boolean;
  as?: ElementType;
} & OpinionModel;

const MiddleDot = () => <span className="mx-1">{' · '}</span>;

export const ArticleHeader = ({ isShowStock = true, isShowDirection = true, as: As = 'small', ...article }: ArticleHeaderProps) => {
  const { uid, symbol, direction } = article;
  const { data: user } = useUserQuery(uid);
  const stock = useStockQuery(symbol);
  return (
    <As className="d-flex align-items-center">
      {(isShowDirection || isShowStock) && (
        <>
          {isShowDirection && (direction === 'down' ? <GraphDownArrow /> : <GraphUpArrow />)}
          {isShowStock && stock && (
            <Link to={`/stocks/${stock.symbol}/opinions`} className="text-decoration-none text-secondary ms-2">{stock.krShortName}</Link>
          )}
          <MiddleDot />
        </>
      )}
      <span className="fw-bold">{user?.displayName}</span>
    </As>
  );
};
